import $ from 'jquery';

$(document).ready(function() {
    $('.js-modal-game-slider').slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        responsive: [
        {
            breakpoint: 700,
            settings: {
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                infinite: false,
           }
        }
        ]
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/game-one/game-slider.js